import objectAssign from 'object-assign';
import { handleActions } from 'redux-actions';

const initialState = {
  location: 'Amagerbro, Denmark',
  city: 'Dives sur Mer',
  country: '250',
  countryName: 'France',
  description: '250',
  propertyId: 'A05900',
  street: 'A05900',
  imageUrl: 'http://sdc.novasol.com/pic/600/g00/g0047_activity_01.jpg',
  information: {
    name: null,
    quality: 4,
    buildYear: '1970',
    modernizedYear: '2014',
    switchDay: 6,
    minimumDays: 7,
    type: 'H',
    adultCount: 4,
    childrenCount: 3,
    extraBedCount: 2,
    sunBedCount: 0,
    allowedPetCount: 2,
    petsPrice: '',
    babyChairCount: 1,
    cotCount: 1,
    kidsFreeOfCharge: 2,
    catalogue: [],
    catalogueHouse: null,
    productNotes: null,
  },
};

// @todo add rental.spec.js

const rentalAppState = handleActions({
  INIT_FROM_DRUPAL: (state) => {
    let newState;
    const globalRental = window.globalRental || undefined;
    const novasolData = window.novasolData || undefined;
    if (globalRental instanceof Object) {
      newState = objectAssign({},
        state,
        globalRental);
    }
    if (novasolData instanceof Object) {
      newState.imageUrl = novasolData.imageUrl;
      newState.freeCancellation = novasolData.freeCancellation;
      newState.isDanishProperty = novasolData.isDanishProperty;
      newState.timeoutModal = novasolData.timeoutModal;
    }
    return newState || state;
  },
},
initialState);

export default rentalAppState;
